import React, { useState, useEffect, useMemo } from "react";
import { useHookstate } from "@hookstate/core";
import { useDispatch, useSelector } from "react-redux";
import { SelectTagCar, MsgToCar, PresetMessages, AddCar } from "../MapStyled";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import {
  Tooltip,
  Checkbox,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import CheckIcon from "assets/svgIcons/CheckIcon";
import AddRoundIcon from "assets/svgIcons/PlusIcon";
import RadioCheckIcon from "assets/svgIcons/RadioCheckedIcon";
import RadioUncheckIcon from "assets/svgIcons/RadioUncheckIcon";
import FormGroup from "@mui/material/FormGroup";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import CloseIcon from "assets/svgIcons/CloseIcon";
import TimeFilterIcon from "assets/svgIcons/TimeFilterIcon";
import BatteryFilterIcon from "assets/svgIcons/BatteryFilterIcon";
import SearchIcon from "assets/svgIcons/SearchIcon";
import MsgArrowIcon from "../../../../../assets/icons/FilterIcon/msg-arrow-icon.png";
import StyledSlider from "../../../../../commonComponents/Slider";
import {
  MAP_GLOBAL_STATES,
  FLEET_GLOBAL_STATES,
  CAR_NUMBER_MESSAGE,
  CHATMESSAGE,
  SITEID_GLOBAL_STATE
} from "../../../../../globalStore/globalStore";
import { useFilteredCarsHook } from "../../../../../customHooks/useFilterData";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import MembercarIcon from "assets/svgIcons/CarType/MembercarIcon";
import FilterShildIcon from "assets/svgIcons/FilterShildIcon";
import FilterDineIcon from "assets/svgIcons/FilterDineIcon";
import FilterBlockIcon from "assets/svgIcons/FilterBlockIcon";
import FilterTagsIcon from "assets/svgIcons/NotCommunicating";
import { isUserAdmin, isUserSupport, getFeatureSetOption, getFeaturesList,memberCarTrackingLevel } from "constant";
import SpecialNeedsIcon from "assets/svgIcons/CarType/SpecialNeeds";
import FilterCarIcon from "assets/svgIcons/FilterCarIcon";
import FilterFlagIcon from "assets/svgIcons/FilterFlagIcon";

export const MsgToSelectedCarsCmp = (props) => {
  const { t } = useTranslation();

  const location = useLocation();

  const [okResponse, setOkResponse] = useState(false);
  const [yesNoResponse, setYesNoResponse] = useState(false);
  const [noneResponse, setNoneResponse] = useState(true);
  const [alert, setAlert] = useState(false);
  const [priority, setPriority] = useState(false);
  const [buttonDetector, setButtonDetector] = useState(true);
  const [highlightGpsiCarIds, setHighlightGpsiCarIds] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [highlightCar, setHighlightCar] = useState([]);
  const [messageInput, setMessageInput] = useState("");
  const [showPresetMessage, setShowPresetMessage] = useState(false);
  const [showCarBox, setShowCarBox] = useState(false);
  const [carsType, setCarsType] = useState(-999);
  const [displayLocationData] = useState(false);
  const [showTagCars, setShowTagCars] = useState(false);
  const [showMessageBox] = useState(false);

  const dispatch = useDispatch();

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const {
    selectedCarList,
    selectedCarList2,
    selectedCarInBox,
    setMsgToSingleCar,
  } = useHookstate(FLEET_GLOBAL_STATES);

  const { showTaggedCar, showMessageBoxForSingleCar } = useHookstate(MAP_GLOBAL_STATES);

  const {
    setCarNumber,
    carMessageSelector,
    carsForMessagesGetter,
    carsGpsSelectorData,
    carsForMessagesGetter2,
    carsGpsSelectorData2,
    carMessageDataHandler,
    carMessageID,
  } = useHookstate(CAR_NUMBER_MESSAGE);

  // Mirror the X-button reset (#38471): MUI Modal unmounts its children when
  // open becomes false, so this also fires on outside-click / Escape close.
  useEffect(() => {
    return () => {
      showMessageBoxForSingleCar.set(false);
      carsForMessagesGetter.set([]);
      carsGpsSelectorData.set([]);
      setCarNumber.set(null);
      carMessageDataHandler.set(false);
    };
  }, []);

  const { cannedMessagesData } = useSelector((state) => state.commonReducers) || [];
  const { getUserRole, siteSettingsData } = useSelector((state) => state.commonReducers) || [];

  const enableMemberCar = (isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) || (!getFeatureSetOption(
    siteSettingsData?.Features,
    getFeaturesList().member_cars
  ) && siteSettingsData?.MemberCarTrackingLevel != memberCarTrackingLevel.Never));

  // Car type filter states
  const [fleetCars, setFleetCars] = useState(true);
  const [specialCars, setSpecialCars] = useState(true);
  const [marshalCars, setMarshalCars] = useState(true);
  const [beverageCars, setBeverageCars] = useState(true);
  const [notInUseCars, setNotInUseCars] = useState(true);
  const [carsNotCommunicating, setCarsNotCommunicating] = useState(true);
  const [memberCars, setMemberCars] = useState(enableMemberCar);
  const [memberSpecialCars, setMemberSpecialCars] = useState(enableMemberCar);

  // Pace and battery filter states
  const [filterIconColor, setFilterIconColor] = useState(false);
  const [filterIconColorTime, setFilterIconColorTime] = useState(false);
  const [filterIconColorBattery, setFilterIconColorBattery] = useState(false);
  const [filterIconColorBatteryRed, setFilterIconColorBatteryRed] = useState(false);

  // Pace/Battery filter configuration
  const paceBatteryFilters = useMemo(() => [
    {
      id: 'paceWarning',
      title: t("Cars_Pace_Warning"),
      Icon: TimeFilterIcon,
      isActive: filterIconColor,
      setActive: setFilterIconColor,
      iconColor: "#FFE500"
    },
    {
      id: 'paceCritical',
      title: t("Cars_Pace_Critical"),
      Icon: TimeFilterIcon,
      isActive: filterIconColorTime,
      setActive: setFilterIconColorTime,
      iconColor: "#FA3C30"
    },
    {
      id: 'batteryWarning',
      title: t("Cars_Battery_Warning"),
      Icon: BatteryFilterIcon,
      isActive: filterIconColorBattery,
      setActive: setFilterIconColorBattery,
      iconColor: "#FFE500"
    },
    {
      id: 'batteryCritical',
      title: t("Cars_Battery_Critical"),
      Icon: BatteryFilterIcon,
      isActive: filterIconColorBatteryRed,
      setActive: setFilterIconColorBatteryRed,
      iconColor: "#FA3C30"
    }
  ], [t, filterIconColor, filterIconColorTime, filterIconColorBattery, filterIconColorBatteryRed]);

  // Car type filter configuration
  const carTypeFilters = useMemo(() => {
    const filters = [
      {
        id: 'fleet',
        title: t("Fleet_cars"),
        Icon: FilterCarIcon,
        isActive: fleetCars,
        setActive: setFleetCars,
        iconProps: {
          bgcolor: fleetCars ? "var(--theme-background)" : "var(--input-background)",
          color: fleetCars ? "var(--input-background)" : "var(--text-secondary)",
          border: fleetCars ? "#FFE500" : "#707374"
        }
      },
      {
        id: 'special',
        title: t("Special_needs_cars"),
        Icon: FilterFlagIcon,
        isActive: specialCars,
        setActive: setSpecialCars,
        iconProps: {
          bgcolor: specialCars ? "var(--theme-background)" : "var(--input-background)",
          color: specialCars ? "var(--input-background)" : "#0026AC",
          border: specialCars ? "var(--theme-background)" : "var(--side-nav-btn-border-color)"
        }
      },
      {
        id: 'marshal',
        title: t("Marshal_cars"),
        Icon: FilterShildIcon,
        isActive: marshalCars,
        setActive: setMarshalCars,
        iconProps: {
          bgcolor: marshalCars ? "var(--theme-background)" : "var(--input-background)",
          color: marshalCars ? "var(--input-background)" : "#49B3E0",
          border: marshalCars ? "var(--theme-background)" : "var(--side-nav-btn-border-color)"
        }
      },
      {
        id: 'beverage',
        title: t("Beverage_cars"),
        Icon: FilterDineIcon,
        isActive: beverageCars,
        setActive: setBeverageCars,
        iconProps: {
          bgcolor: beverageCars ? "var(--theme-background)" : "var(--input-background)",
          color: beverageCars ? "var(--input-background)" : "#229D08",
          border: beverageCars ? "var(--theme-background)" : "var(--side-nav-btn-border-color)"
        }
      }
    ];

    if (enableMemberCar) {
      filters.push(
        {
          id: 'member',
          title: t("Member_car"),
          Icon: MembercarIcon,
          isActive: memberCars,
          setActive: setMemberCars,
          iconProps: {
            width: 30,
            height: 30,
            bg: memberCars ? "var(--theme-background)" : "var(--input-background)",
            color: memberCars ? "var(--input-background)" : "#00A000",
            stroke: memberCars ? "var(--theme-background)" : "var(--side-nav-btn-border-color)"
          }
        },
        {
          id: 'memberSpecial',
          title: t("Member_/_Special_Needs"),
          isActive: memberSpecialCars,
          setActive: setMemberSpecialCars,
          renderCustomIcon: () => (
            <div style={{ display: "inline-flex", gap: 1 }}>
              <MembercarIcon
                width={30}
                height={30}
                bg={memberSpecialCars ? "var(--theme-background)" : "var(--input-background)"}
                color={memberSpecialCars ? "var(--input-background)" : "#00A000"}
                stroke={memberSpecialCars ? "var(--theme-background)" : "var(--side-nav-btn-border-color)"}
              />
              <SpecialNeedsIcon
                width={20}
                height={30}
                bg={memberSpecialCars ? "var(--theme-background)" : "#0026AC"}
              />
            </div>
          )
        }
      );
    }

    filters.push(
      {
        id: 'notInUse',
        title: t("Cars_not_in_use"),
        Icon: FilterBlockIcon,
        isActive: notInUseCars,
        setActive: setNotInUseCars,
        iconProps: {
          bgcolor: notInUseCars ? "var(--theme-background)" : "var(--input-background)",
          color: notInUseCars ? "var(--input-background)" : "#FA3C30",
          border: notInUseCars ? "var(--theme-background)" : "var(--side-nav-btn-border-color)"
        }
      },
      {
        id: 'notCommunicating',
        title: t("Cars_not_communicating"),
        Icon: FilterTagsIcon,
        isActive: carsNotCommunicating,
        setActive: setCarsNotCommunicating,
        className: carsNotCommunicating ? "active not-com" : "not-com",
        iconProps: {
          bgcolor: carsNotCommunicating ? "var(--theme-background)" : "var(--input-background)",
          color: carsNotCommunicating ? "var(--input-background)" : "#3134EB",
          border: carsNotCommunicating ? "var(--theme-background)" : "var(--side-nav-btn-border-color)",
          fill: carsNotCommunicating ? "var(--theme-background)" : "var(--input-background)"
        }
      }
    );

    return filters;
  }, [t, enableMemberCar, fleetCars, marshalCars, beverageCars, specialCars, memberCars, memberSpecialCars, notInUseCars, carsNotCommunicating]);

  const { getSelectedCarsState } = useFilteredCarsHook({
    marshalCars: marshalCars,
    specialCars: specialCars,
    memberCars: memberCars,
    memberSpecialCars: memberSpecialCars,
    beverageCars: beverageCars,
    fleetCars: fleetCars,
    notInUseCars: notInUseCars,
    notCommunicatingCars: carsNotCommunicating,
    paceWarning: filterIconColor,
    paceCritical: filterIconColorTime,
    batteryWarning: filterIconColorBattery,
    batteryCritical: filterIconColorBatteryRed,
    carsInEnergySaverMode: true
  });

  useEffect(() => {
    setHighlightCar([...highlightCar, ...carMessageSelector.get()]);
  }, [
    filterIconColor,
    filterIconColorTime,
    filterIconColorBattery,
    filterIconColorBatteryRed,
  ]);

  useEffect(() => {
    let carsData = JSON.parse(JSON.stringify(getSelectedCarsState.get()));
    let filterCars = [...carsData];
    if (setMsgToSingleCar.get() && filterCars.length > 0) {
      let car = filterCars.filter(
        (it) => setMsgToSingleCar.get() === it.Car.CarNumber
      );
      if (car?.length > 0)
        setCarsType(
          [1, 2, 3, 4].some((item) => item === car[0].Car.CarType)
            ? "-999"
            : car[0].Car.CarType
        );
    }
    showFilteredCars();
  }, [
    filterIconColor,
    filterIconColorBattery,
    filterIconColorTime,
    filterIconColorBatteryRed,
    searchInput,
    carsType,
    setMsgToSingleCar.get(),
    fleetCars,
    marshalCars,
    specialCars,
    memberCars,
    memberSpecialCars,
    beverageCars,
    notInUseCars,
    carsNotCommunicating,
  ]);

  useEffect(() => {
    if (!showCarBox) {
      setFleetCars(true);
      setMarshalCars(true);
      setSpecialCars(true);
      setMemberCars(enableMemberCar);
      setMemberSpecialCars(enableMemberCar);
      setBeverageCars(true);
      setNotInUseCars(true);
      setCarsNotCommunicating(true);
    }
  }, [showCarBox]);

  useEffect(() => {
    if (carsForMessagesGetter2.get().length !== 0 && carsGpsSelectorData2.get().length !== 0 && carMessageDataHandler.get()) {
      carsForMessagesGetter.set([...carsForMessagesGetter2.get()]);
      carsGpsSelectorData.set([...carsGpsSelectorData2.get()]);
    }
  }, []);

  useEffect(() => {
    if (messageInput !== "") {
      setButtonDetector(false);
    } else {
      setButtonDetector(true);
    }
  }, [priority, alert, noneResponse, okResponse, yesNoResponse, messageInput]);

  const showFilteredCars = () => {
    let carsData = JSON.parse(JSON.stringify(getSelectedCarsState.get()));
    let filterCars = [...carsData];
    if (!setMsgToSingleCar.get()) {
      let tagCars = filterCars.filter((it) =>
        selectedCarList.get().some((item) => item === it.Car.CarNumber)
      );
      setHighlightCar(tagCars.map((it) => it.Car.CarNumber));
      setHighlightGpsiCarIds(
        tagCars.map((it) => {
          return {
            gpsiCarId: it.Car.GpsiCarId,
            carType: it.Car.carType,
          };
        })
      );
    } else {
      if (
        filterCars.some((it) => setMsgToSingleCar.get() === it.Car.CarNumber)
      ) {
        setHighlightCar([setMsgToSingleCar.get()]);
        setHighlightGpsiCarIds(
          filterCars
            .filter((it) => setMsgToSingleCar.get() === it.Car.CarNumber)
            .map((it) => {
              return {
                gpsiCarId: it.Car.GpsiCarId,
                carType: it.Car.carType,
              };
            })
        );
      }
    }
  };

  const setTagCarOnMap = (carNumber, gpsiCarId, carType) => {
    const exist = highlightCar.find((item) => item === carNumber);
    const gpsExist = highlightGpsiCarIds.find((item) => item.gpsiCarId === gpsiCarId);
    if (exist && gpsExist) {
      let newData = highlightCar.filter((item) => item !== carNumber);
      let newGpsData = highlightGpsiCarIds.filter((item) => item.gpsiCarId !== gpsiCarId);
      setHighlightCar(newData);
      carMessageSelector.set(newData);
      selectedCarInBox.set(newData);
      setHighlightGpsiCarIds(newGpsData);
    } else {
      setHighlightCar([...highlightCar, carNumber]);
      setHighlightGpsiCarIds([...highlightGpsiCarIds, { gpsiCarId, carType }]);
      carMessageSelector.set([...carMessageSelector.get(), carNumber]);
    }

    const carExist = carsForMessagesGetter.get().find((item) => item === carNumber);

    const carGpsExist = carsForMessagesGetter.get().find((item) => item === carNumber);

    if (carExist) {
      let newData = carsForMessagesGetter.get().filter((item) => item !== carNumber);
      carsForMessagesGetter.set([...newData]);
    } else {
      carsForMessagesGetter.set([...carsForMessagesGetter.get(), carNumber]);
    }

    if (carGpsExist) {
      let newData = carsGpsSelectorData.get().filter((item) => item !== gpsiCarId);
      carsGpsSelectorData.set([...newData]);
    } else {
      carsGpsSelectorData.set([...carsGpsSelectorData.get(), gpsiCarId]);
    }
    showTaggedCar.set(carNumber);
  };

  const handleResetMessage = () => {
    if (showCarBox) {
      setMessageInput("");
      setHighlightCar([]);
      carsForMessagesGetter.set([]);
      carsForMessagesGetter2.set([]);
      carsGpsSelectorData.set([]);
      carsGpsSelectorData2.set([]);
      setHighlightGpsiCarIds([]);
    } else {
      setMessageInput("");
    }
    setShowTagCars(false);
    setMessageInput("");
    setFilterIconColorBatteryRed(false);
    setFilterIconColorBattery(false);
    setFilterIconColor(false);
    setFilterIconColorTime(false);
    setCarsType(-999);
    setSearchInput("");
    setPriority(false);
    setAlert(false);
    setOkResponse(false);
    setNoneResponse(true);
    setYesNoResponse(false);
  };

  const sendMessageToCar = () => {
    var options = 0;
    if (priority) options |= 0x02;
    if (alert) options |= 0x04;
    if (okResponse) options |= 0x08;
    if (yesNoResponse) options |= 0x10;
    if (carsGpsSelectorData.get().length !== 0) {
      if (messageInput !== "") {
        if (location.pathname === "/messages") {
          let dismissedIds = JSON.parse(localStorage.getItem("dismissedIds"));
          dismissedIds.push(carMessageID.get());
          localStorage.setItem("dismissedIds", JSON.stringify(dismissedIds));
        }

        for (let value of carsGpsSelectorData.get()) {
          dispatch(
            COMMON_SERVICES.sendMessagesServices(
              messageInput,
              options,
              value.toString(),
              Number(siteId.get())
            )
          );
        }
        props.cancelClick();
      } else {
        alert("Can't send empty message");
      }
    } else {
      alert("Please select car");
    }
    setMessageInput("");
    setFilterIconColor(false);
    setFilterIconColorBattery(false);
    setFilterIconColorTime(false);
    setFilterIconColorBatteryRed(false);
    carsForMessagesGetter.set([]);
    carsForMessagesGetter2.set([]);
    carsGpsSelectorData.set([]);
    carsGpsSelectorData2.set([]);
    selectedCarList.set([]);
    selectedCarList2.set([]);
    setCarNumber.set(null);
    setNoneResponse(true);
    setOkResponse(false);
    setYesNoResponse(false);
    setAlert(true);
    setPriority(true);
  };

  const { MessageCount } = useHookstate(CHATMESSAGE);

  const setMessage = (message, e) => {
    if (message) {
      setMessageInput(message.Body);
      setAlert(message.Audible);
      setPriority(message.Priority);
      setOkResponse(message.OkResponse);
      setYesNoResponse(message.YesNoResponse);
      if (!message.OkResponse && !message.YesNoResponse) {
        setNoneResponse(true);
      } else {
        setNoneResponse(false);
      }
      setShowPresetMessage(false);
    } else {
      setMessageInput(e.target.value);
    }
  };

  const setShowAllData = (flag) => {
    if (flag === "All") {
      let carsData = JSON.parse(JSON.stringify(getSelectedCarsState.get()));
      const carsNumberData =
        carsData && carsData.length !== 0
          ? carsData.map((item) => {
            return item?.Car?.CarNumber;
          })
          : [];
      const carsGpsData =
        carsData && carsData.length !== 0
          ? carsData.map((item) => {
            return item?.Car?.GpsiCarId;
          })
          : [];
      carsForMessagesGetter.set([...carsNumberData]);
      carsGpsSelectorData.set([...carsGpsData]);
      let filteredCarsList =
        carsData && carsData.length !== 0
          ? carsData.map((carNum) => {
            return {
              carNumber: carNum.Car.CarNumber,
              GpsiCarId: carNum.Car.GpsiCarId,
              carType: carNum.Car.CarType,
            };
          })
          : [];
      setHighlightCar(filteredCarsList.map((it) => it.carNumber));
      setHighlightGpsiCarIds(
        filteredCarsList.map((it) => {
          return {
            gpsiCarId: it.GpsiCarId,
            carType: it.carType,
          };
        })
      );
    } else {
      setHighlightCar([]);
      setHighlightGpsiCarIds([]);
      carsForMessagesGetter.set([]);
      carsGpsSelectorData.set([]);
    }
  };

  const handleToCarTitle = () => {
    return carsForMessagesGetter.get().length > 1
      ? carsForMessagesGetter.get().length < 5
        ? `${t("To_cars")} ${carsForMessagesGetter.get().map(x => x)}`
        : `To ${carsForMessagesGetter.get().length} cars`
      : `${t("To_car")} ${carsForMessagesGetter.get()}`;
  }

  return (
    <>
      <SelectTagCar className="fleet-car-msg">
        <div className="inner-wrapper">
          <div className="close-icon-wrapper">
            <CloseIcon
              onClick={() => {
                props.cancelClick();
                showMessageBoxForSingleCar.set(false);
                carsForMessagesGetter.set([]);
                carsGpsSelectorData.set([]);
                setCarNumber.set(null);
                carMessageDataHandler.set(false);
              }}
              width={22}
              height={22}
            />
          </div>

          <div className="box-heading">
            <h5>
              {handleToCarTitle()}
            </h5>
            <AddCar
              onClick={() => {
                setShowCarBox(!showCarBox);
              }}
            >
              <AddRoundIcon />
              {t("Cars")}
            </AddCar>
          </div>
          {showCarBox ? (
            <div>
              <div className="filter-header">
                <h3>{t("Filters")}</h3>

                <div className="pace-battery-filters">
                  {paceBatteryFilters.map((filter) => {
                    const { Icon } = filter;
                    return (
                      <Tooltip key={filter.id} title={filter.title} placement="top" arrow>
                        <span>
                          <Icon
                            onClick={() => filter.setActive(!filter.isActive)}
                            bgcolor={filter.isActive ? "#82dbcf" : "#ffff"}
                            color={filter.iconColor}
                          />
                        </span>
                      </Tooltip>
                    );
                  })}
                </div>
              </div>

              <div className="filter-content">
                <div className="white-filter">
                  {carTypeFilters.map((filter) => {
                    if (filter.renderCustomIcon) {
                      return (
                        <Tooltip key={filter.id} title={filter.title} placement="top" arrow>
                          <button onClick={() => filter.setActive(!filter.isActive)}>
                            {filter.renderCustomIcon()}
                          </button>
                        </Tooltip>
                      );
                    }

                    const { Icon } = filter;
                    return (
                      <Tooltip key={filter.id} title={filter.title} placement="top" arrow>
                        <button
                          className={filter.className}
                          onClick={() => filter.setActive(!filter.isActive)}
                        >
                          <Icon {...filter.iconProps} />
                        </button>
                      </Tooltip>
                    );
                  })}
                </div>

              </div>
              {displayLocationData ? <StyledSlider /> : <></>}

              <div className="search-wrapper">
                <input
                  placeholder={t("Search_car_no")}
                  style={{ color: "#000", fontWeight: "bold" }}
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <SearchIcon />
              </div>
              <div className="car-selection">
                <div className="car-count">
                  <div>
                    <p
                      onClick={(e) => {
                        setShowAllData("All");
                      }}
                    >
                      {t("All")}
                    </p>{" "}
                    I{" "}
                    <p
                      onClick={(e) => {
                        setShowAllData("None");
                      }}
                    >
                      {t("None")}
                    </p>
                  </div>
                  <div>
                    <span>
                      {getSelectedCarsState
                        .get()
                        .filter((it) =>
                          carsForMessagesGetter
                            .get()
                            .some((item) => item === it.Car.CarNumber)
                        )?.length
                        ? getSelectedCarsState
                          .get()
                          .filter((it) =>
                            carsForMessagesGetter
                              .get()
                              .some((item) => item === it.Car.CarNumber)
                          )?.length
                        : 0}
                    </span>
                    &nbsp;
                    {carsForMessagesGetter.get().length > 1
                      ? t("cars_selected")
                      : t("car_selected")}
                  </div>
                </div>
                <div className="car-number">
                  {getSelectedCarsState.get() &&
                    getSelectedCarsState.get().length !== 0 ? (
                    getSelectedCarsState
                      .get()
                      .filter((item) => {
                        if (searchInput === "") {
                          return item.Car.CarNumber;
                        } else if (
                          item.Car.CarNumber.toString()
                            .toLowerCase()
                            .includes(searchInput.toLowerCase())
                        ) {
                          return item.Car.CarNumber;
                        }
                      })
                      .sort((a, b) => a.Car.CarNumber - b.Car.CarNumber)
                      .map((item, index) => (
                        <button
                          key={index}
                          className={
                            carsForMessagesGetter
                              .get()
                              .includes(item.Car.CarNumber)
                              ? "active"
                              : ""
                          }
                          onClick={() =>
                            setTagCarOnMap(
                              item.Car.CarNumber,
                              item.Car.GpsiCarId,
                              item.Car.CarType
                            )
                          }
                        >
                          {item.Car.CarNumber}
                        </button>
                      ))
                  ) : (
                    <p>No Car Found</p>
                  )}
                </div>
                {showMessageBox ? (
                  <></>
                ) : (
                  <div className="reset-section">
                    {displayLocationData ? (
                      <div className="action-wrapper">
                        <button className="send-btn">{t("Ok")}</button>
                        <button className="send-btn">{t("Reset")}</button>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <></>
          )}
          <MsgToCar>
            <div className="add-msg">
              <p>{t("Preset_messages")}</p>
              <AddRoundIcon
                onClick={() => setShowPresetMessage(!showPresetMessage)}
              />
            </div>
            <div className="text-area">
              <textarea
                maxLength={182}
                id="w3review"
                name="w3review"
                rows="4"
                placeholder={t("Type_your_message")}
                value={messageInput}
                onChange={(e) => setMessage("", e)}
              ></textarea>
            </div>
            <div className="checkbox-wrapper">
              <FormGroup row>
                <Tooltip title={t("Set_message_priority")} placement="top">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={priority}
                        onChange={() => {
                          setPriority(!priority);
                        }}
                        inputProps={{ "aria-label": "controlled" }}
                        icon={<UnCheckIcon width={15} height={15} />}
                        checkedIcon={<CheckIcon width={15} height={15} />}
                      />
                    }
                    label={t("Priority")}
                  />
                </Tooltip>
                <Tooltip title={t("Set_sound_on_message")} placement="top">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={alert}
                        onChange={() => {
                          setAlert(!alert);
                        }}
                        inputProps={{ "aria-label": "controlled" }}
                        icon={<UnCheckIcon width={15} height={15} />}
                        checkedIcon={<CheckIcon width={15} height={15} />}
                      />
                    }
                    label={t("Alert")}
                  />
                </Tooltip>
              </FormGroup>
            </div>
            <div className="response-section">
              <p>{t("Response")}</p>
              <div>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <FormControlLabel
                    value="noneResponse"
                    control={
                      <Radio
                        icon={<RadioUncheckIcon width={15} height={15} />}
                        checkedIcon={<RadioCheckIcon width={15} height={15} />}
                        checked={noneResponse}
                        onChange={(e) => {
                          setNoneResponse(e.target.checked);
                          setOkResponse(!e.target.checked);
                          setYesNoResponse(!e.target.checked);
                        }}
                      />
                    }
                    label={t("None")}
                  />
                  <FormControlLabel
                    value="okResponse"
                    control={
                      <Radio
                        icon={<RadioUncheckIcon width={15} height={15} />}
                        checkedIcon={<RadioCheckIcon width={15} height={15} />}
                        onChange={(e) => {
                          setOkResponse(e.target.checked);
                          setNoneResponse(!e.target.checked);
                          setYesNoResponse(!e.target.checked);
                        }}
                        checked={okResponse}
                      />
                    }
                    label={t("Ok")}
                  />
                  <FormControlLabel
                    value="yesNoResponse"
                    control={
                      <Radio
                        icon={<RadioUncheckIcon width={15} height={15} />}
                        checkedIcon={<RadioCheckIcon width={15} height={15} />}
                        checked={yesNoResponse}
                        onChange={(e) => {
                          setYesNoResponse(e.target.checked);
                          setNoneResponse(!e.target.checked);
                          setOkResponse(!e.target.checked);
                        }}
                      />
                    }
                    label={t("Yes/No")}
                  />
                </RadioGroup>
              </div>
              <div className="action-wrapper">
                <button
                  disabled={buttonDetector}
                  style={{
                    cursor:
                      carsForMessagesGetter.get() &&
                        carsForMessagesGetter.get().length !== 0
                        ? "pointer"
                        : "context-menu",
                  }}
                  className={
                    buttonDetector ? "disabled send-btn" : " active send-btn"
                  }
                  onClick={sendMessageToCar}
                >
                  {t("Send")}
                </button>
                <button
                  className={
                    carsForMessagesGetter.get() &&
                      carsForMessagesGetter.get().length !== 0
                      ? " send-btn"
                      : "disabled send-btn"
                  }
                  onClick={handleResetMessage}
                >
                  {t("Reset")}
                </button>
              </div>
            </div>
          </MsgToCar>
          <>
            {displayLocationData && showTagCars === false ? (
              <div className="action-wrapper">
                <button className="send-btn">{t("Ok")}</button>
                <button className="reset">{t("Reset")}</button>
              </div>
            ) : (
              <></>
            )}
          </>
        </div>
        {showPresetMessage || showMessageBox ? (
          <PresetMessages>
            <div>
              <div className="heading-section">
                <p>{t("Preset_messages")}</p>

                <CloseIcon
                  onClick={() => setShowPresetMessage(false)}
                  width={22}
                  height={22}
                />
              </div>
              <ul>
                {cannedMessagesData && cannedMessagesData.length !== 0 ? (
                  cannedMessagesData.map((item) => (
                    <li
                      onClick={() => {
                        setMessage(item);
                        setAlert(item.Audible);
                        setPriority(item.Priority);
                      }}
                    >
                      <span style={{ cursor: "pointer" }}>
                        <img src={MsgArrowIcon} alt="Msg-Arrow-Icon" />
                      </span>{" "}
                      {item.Body}
                    </li>
                  ))
                ) : (
                  <></>
                )}
              </ul>
            </div>
          </PresetMessages>
        ) : (
          <></>
        )}
      </SelectTagCar>
    </>
  );
};
